// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3420c","footer":"ReportModalFilter_footer__1Ht42"};